<!-- ==============================================================
     Horizontal top nav — grouped by separator (Vouchers, Assets,
     Administration ...). Links listed before the first separator
     (Dashboard) are standalone top-level links.

     Uses plain <ul>/<li> with native elements: no mat-nav-list /
     mat-list-item. The component pre-computes `menu` in ngOnInit,
     so this template does NO method calls — the nav is rendered
     from a stable array reference.
     ============================================================== -->
<ul class="h-nav" role="menubar">
  <ng-container *ngFor="let entry of menu">

    <!-- ===== Standalone top-level link (Dashboard) ===== -->
    <li class="h-nav__item h-nav__item--link"
        role="none"
        *ngIf="entry.type === 'link'">
      <a class="h-nav__link"
         role="menuitem"
         [routerLink]="'/' + asLink(entry).state"
         [matTooltip]="asLink(entry).name | translate"
         [routerLinkActiveOptions]="{ exact: asLink(entry).exact }"
         routerLinkActive="is-active">
        <mat-icon class="h-nav__icon">{{ asLink(entry).icon }}</mat-icon>
        <span class="h-nav__label">{{ asLink(entry).name | translate }}</span>
      </a>
    </li>

    <!-- ===== Group with hover dropdown ===== -->
    <li class="h-nav__item h-nav__item--group"
        role="none"
        *ngIf="entry.type === 'group'"
        [class.is-active]="activeGroup === asGroup(entry).name"
        [class.is-just-clicked]="justClicked.has(asGroup(entry).name)"
        (mouseleave)="onGroupLeave(asGroup(entry).name)">
      <button type="button"
              class="h-nav__link h-nav__trigger"
              role="menuitem"
              aria-haspopup="true">
        <mat-icon class="h-nav__icon">{{ asGroup(entry).icon }}</mat-icon>
        <span class="h-nav__label">{{ asGroup(entry).name | translate }}</span>
        <mat-icon class="h-nav__caret">keyboard_arrow_down</mat-icon>
      </button>

      <ul class="h-nav__dropdown" role="menu">
        <li class="h-nav__dropdown-item"
            role="none"
            *ngFor="let child of asGroup(entry).children">
          <div class="h-nav__dropdown-subheader" *ngIf="child.type === 'subheader'">{{ child.name | translate }}</div>
          <a class="h-nav__dropdown-link"
             *ngIf="child.type !== 'subheader'"
             role="menuitem"
             [routerLink]="'/' + child.state"
             [matTooltip]="child.name | translate" matTooltipPosition="right"
             routerLinkActive="is-active"
             (click)="onChildClick(asGroup(entry).name)">
            <mat-icon class="h-nav__dropdown-icon">{{ child.icon }}</mat-icon>
            <span>{{ child.name | translate }}</span>
          </a>
        </li>
      </ul>
    </li>

  </ng-container>
</ul>
